import React from "react"
import { getQueryParam } from "../../../utils/url"

export const useQueryParam = (name: string) => {
  const [param, setParam] = React.useState<string>()
  React.useEffect(() => {
    setParam(getQueryParam(window.location, name))
  }, [])
  return param
}
